import DeliveryAddressModal from './DeliveryAddressModal';
import DeliveryAddressForm from './DeliveryAddressForm';

export default {
  DeliveryAddressModal,
  DeliveryAddressForm,
};
